interface RateLimitEntry {
	count: number;
	lastLog: number;
	suppressed: number;
}

export class RateLimiter {
	private readonly cache = new Map<string, RateLimitEntry>();
	private readonly windowMs: number;
	private readonly maxLogs: number;

	constructor(windowMs = 5000, maxLogs = 10) {
		this.windowMs = windowMs;
		this.maxLogs = maxLogs;
	}

	shouldSuppress(message: string): boolean {
		const now = Date.now();
		const entry = this.cache.get(message);

		if (!entry) {
			this.cache.set(message, { count: 1, lastLog: now, suppressed: 0 });
			return false;
		}

		if (now - entry.lastLog > this.windowMs) {
			if (entry.suppressed > 0) {
				console.warn(
					`[RateLimiter] Suppressed ${entry.suppressed} duplicate log(s) for: "${message}"`,
				);
			}
			this.cache.set(message, { count: 1, lastLog: now, suppressed: 0 });
			return false;
		}

		entry.count++;

		if (entry.count > this.maxLogs) {
			entry.suppressed++;
			return true;
		}

		return false;
	}

	clear(): void {
		this.cache.clear();
	}
}
